var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPublicTransportItem
    ? _c(
        "div",
        {
          staticClass: "public-transport-item-container ticket",
          class: { isSubConfig: _vm.isSubconfig, unselectable: _vm.isDisabled },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "public-transport-item public-transport-item--description",
            },
            [
              _vm.product
                ? [
                    _c(
                      "p",
                      {
                        staticClass: "ticket__descriptionTitle",
                        class: { isSubConfig: _vm.isSubconfig },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$tm(_vm.product, "descriptionWebShop"))
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.slotOutOfRange
            ? [
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _vm.$t(
                        "checkout.personalisation.publicTransport.noTicketAvailable"
                      )
                    ) +
                    "\n  "
                ),
              ]
            : [
                _vm.product && _vm.event
                  ? [
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "public-transport-item public-transport-item--use-public-trans",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "checkout-form__field checkout-form__field--radio",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "pub-trans-yes-" + _vm.aoic.id,
                                    },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.aoic.publicTransportConfig
                                              .usePubTrans,
                                          expression:
                                            "aoic.publicTransportConfig.usePubTrans",
                                        },
                                      ],
                                      attrs: {
                                        id: "pub-trans-yes-" + _vm.aoic.id,
                                        name: "pub-trans-yes-" + _vm.aoic.id,
                                        type: "radio",
                                        disabled: _vm.isDisabled,
                                      },
                                      domProps: {
                                        checked:
                                          _vm.aoic.publicTransportConfig
                                            .usePubTrans,
                                        value: true,
                                        checked: _vm._q(
                                          _vm.aoic.publicTransportConfig
                                            .usePubTrans,
                                          true
                                        ),
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            return _vm.$set(
                                              _vm.aoic.publicTransportConfig,
                                              "usePubTrans",
                                              true
                                            )
                                          },
                                          _vm.onChangeSelection,
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "radio__checkMark",
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "checkout.personalisation.publicTransport.yes"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "pub-trans-no-" + _vm.aoic.id,
                                    },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.aoic.publicTransportConfig
                                              .usePubTrans,
                                          expression:
                                            "aoic.publicTransportConfig.usePubTrans",
                                        },
                                      ],
                                      attrs: {
                                        id: "pub-trans-no-" + _vm.aoic.id,
                                        name: "pub-trans-no-" + _vm.aoic.id,
                                        type: "radio",
                                        disabled: _vm.isDisabled,
                                      },
                                      domProps: {
                                        checked:
                                          _vm.aoic.publicTransportConfig
                                            .usePubTrans,
                                        value: false,
                                        checked: _vm._q(
                                          _vm.aoic.publicTransportConfig
                                            .usePubTrans,
                                          false
                                        ),
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            return _vm.$set(
                                              _vm.aoic.publicTransportConfig,
                                              "usePubTrans",
                                              false
                                            )
                                          },
                                          _vm.onChangeSelection,
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "radio__checkMark",
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "checkout.personalisation.publicTransport.no"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.aoic.publicTransportConfig.usePubTrans
                  ? [
                      _vm.slot && _vm.slotIsSingleDate
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "public-transport-item public-transport-item--quota",
                              },
                              [
                                _c("p", { staticClass: "ticket__quotaTitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "checkout.personalisation.publicTransport.slot"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatTimeString")(
                                        _vm.slot.printStart,
                                        _vm.userLanguage
                                      )
                                    ) +
                                      " - " +
                                      _vm._s(
                                        _vm._f("formatTimeString")(
                                          _vm.slot.printEnd,
                                          _vm.userLanguage
                                        )
                                      ) +
                                      " Uhr"
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDateString")(
                                          _vm.slot.printStart,
                                          _vm.userLanguage
                                        )
                                      ) + "\n          "
                                    ),
                                    new Date(_vm.slot.printStart).getDate() !==
                                    new Date(_vm.slot.printEnd).getDate()
                                      ? [
                                          _vm._v(
                                            "\n            - " +
                                              _vm._s(
                                                _vm._f("formatDateString")(
                                                  _vm.slot.printEnd,
                                                  _vm.userLanguage
                                                )
                                              ) +
                                              "\n          "
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        : _vm.event
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "public-transport-item public-transport-item--name-input",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "checkout-form__field form__group--input",
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "name-input-" + _vm.aoic.id,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "checkout.personalisation.publicTransport.firstNameHint"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                        _vm.isSelected
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "global.forms.required"
                                                  )
                                                )
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.aoic.publicTransportConfig
                                              .passengerName,
                                          expression:
                                            "aoic.publicTransportConfig.passengerName",
                                        },
                                      ],
                                      staticClass:
                                        "form__element form__element--input",
                                      attrs: {
                                        id: "name-input-" + _vm.aoic.id,
                                        maxlength: "49",
                                        required: _vm.isSelected,
                                        disabled: !_vm.canChangeName,
                                        placeholder: _vm.$t(
                                          "global.forms.firstNamePlaceHolder"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.aoic.publicTransportConfig
                                            .passengerName,
                                      },
                                      on: {
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.aoic.publicTransportConfig,
                                              "passengerName",
                                              $event.target.value
                                            )
                                          },
                                          _vm.onChangeSelection,
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "name-input__label",
                                        attrs: {
                                          for: "name-input-" + _vm.aoic.id,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "checkout.personalisation.publicTransport.lastNameHint"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                        _vm.isSelected
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "global.forms.required"
                                                  )
                                                )
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.aoic.publicTransportConfig
                                              .passengerSurname,
                                          expression:
                                            "aoic.publicTransportConfig.passengerSurname",
                                        },
                                      ],
                                      staticClass:
                                        "form__element form__element--input",
                                      attrs: {
                                        id: "name-input-" + _vm.aoic.id,
                                        maxlength: "49",
                                        required: _vm.isSelected,
                                        disabled: !_vm.canChangeName,
                                        placeholder: _vm.$t(
                                          "global.forms.lastNamePlaceHolder"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.aoic.publicTransportConfig
                                            .passengerSurname,
                                      },
                                      on: {
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.aoic.publicTransportConfig,
                                              "passengerSurname",
                                              $event.target.value
                                            )
                                          },
                                          _vm.onChangeSelection,
                                        ],
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.productIsMultipleDays
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "public-transport-item public-transport-item--entire-event",
                                    },
                                    [
                                      _c("span", [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "checkout.personalisation.publicTransport.validDuringEntireEvent"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]
                              : [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "public-transport-item public-transport-item--date-select",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "checkout-form__field form__group--select",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for:
                                                  "date-select-" + _vm.aoic.id,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t("global.forms.date")
                                                  ) +
                                                  "\n                "
                                              ),
                                              _vm.isSelected
                                                ? [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "global.forms.required"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form__selectWrapper icon icon-arrow-right",
                                              class: {
                                                disabled: _vm.isSubconfig,
                                              },
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.aoic
                                                          .publicTransportConfig
                                                          .selectedDate,
                                                      expression:
                                                        "aoic.publicTransportConfig.selectedDate",
                                                    },
                                                  ],
                                                  staticClass: "form__select",
                                                  attrs: {
                                                    required: _vm.isSelected,
                                                    id:
                                                      "date-select-" +
                                                      _vm.aoic.id,
                                                    disabled: _vm.isSubconfig,
                                                  },
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.$set(
                                                          _vm.aoic
                                                            .publicTransportConfig,
                                                          "selectedDate",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      },
                                                      _vm.onChangeSelection,
                                                    ],
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.dateSelection,
                                                    function (date) {
                                                      return [
                                                        _vm.isDateSelectable(
                                                          date
                                                        )
                                                          ? _c(
                                                              "option",
                                                              {
                                                                key: date.toLocaleString(),
                                                                domProps: {
                                                                  value:
                                                                    date.toISOString(),
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatDateString"
                                                                    )(
                                                                      date,
                                                                      "de"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "option",
                                                              {
                                                                key: date.toLocaleString(),
                                                                attrs: {
                                                                  disabled: "",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    date.toISOString(),
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatDateString"
                                                                    )(
                                                                      date,
                                                                      "de"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                      ]
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                          ]
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }